type HitlEditCallbacks = {
  onEditComplete: (editedArgs: Record<string, unknown>) => void;
  onApprove?: () => void;
  onReject?: (message?: string) => void;
};

const registry = new Map<string, HitlEditCallbacks>();
const draftArgsByMessageId = new Map<string, Record<string, unknown>>();

export const hitlEditCallbackRegistry = {
  register(hitlMessageId: string, callbacks: HitlEditCallbacks): void {
    registry.set(hitlMessageId, callbacks);
  },

  get(hitlMessageId: string): HitlEditCallbacks | undefined {
    return registry.get(hitlMessageId);
  },

  unregister(hitlMessageId: string): void {
    const prefix = `${hitlMessageId}-`;
    const relatedKeys = [...registry.keys(), ...draftArgsByMessageId.keys()];

    relatedKeys
      .filter((key) => key === hitlMessageId || key.startsWith(prefix))
      .forEach((key) => {
        registry.delete(key);
        draftArgsByMessageId.delete(key);
      });
  },

  setDraftArgs(
    hitlMessageId: string,
    draftArgs: Record<string, unknown> | null,
  ): void {
    if (draftArgs) {
      draftArgsByMessageId.set(hitlMessageId, draftArgs);
    } else {
      draftArgsByMessageId.delete(hitlMessageId);
    }
  },

  getDraftArgs(hitlMessageId: string): Record<string, unknown> | undefined {
    return draftArgsByMessageId.get(hitlMessageId);
  },
};
